import React from 'react';
import UserAvatar from '../../../elements/icons/UserAvatar';
import Link from '../../../elements/Link';
import ListItem from '../../../elements/ListItem/ListItem';
import { ListItemContent } from '../../../elements/ListItem/ListItemContent';
import RightChevron from '../../../elements/RightChevron/RightChevron';
import UserName from '../../../elements/UserName';
import stylesheet from '../EventDirectory-listItems.module.scss';
import { useEventSpeaker } from '../../../../data/hooks/speakers/useEventSpeaker';

// NOTE: speaker uses speaker_id as primary key

const PresentationSpeaker = (props) => {
    const { event, speaker: directorySpeakerData = {} } = props,
        storedSpeaker = useEventSpeaker(event.id, directorySpeakerData.speaker_id) ?? {},
        speaker = {
            ...directorySpeakerData,
            ...storedSpeaker,
        },
        href = ['.', 'speakers', speaker.speaker_id].join('/');

    return speaker.speaker_id ? (
        <li className={[stylesheet.speakerWrapper, 'item'].join(' ')}>
            <ListItem tagName={Link} className={[stylesheet.item, stylesheet.speaker].join(' ')} href={href}>
                <div className="text-center">
                    <UserAvatar user={speaker} round />
                </div>
                <ListItemContent className={stylesheet.name}>
                    <UserName user={speaker} />
                </ListItemContent>
                <RightChevron />
            </ListItem>
        </li>
    ) : null;
};

export default PresentationSpeaker;
